module.exports = __webpack_public_path__ + "img/rke2.d10540bf.svg";